import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { useFormContext } from 'react-hook-form';
import useNotify from 'hooks/useNotify';
import { PreArrivalFormFields } from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import { InternalCustomDataFieldSubType } from 'models/CustomDataField';
import AddCustomFieldModal from './AddCustomFieldModal';

export const modalId = 'add-custom-field-pre-arrival-form-modal';

const useAddCustomFieldModal = () => {
  const { setValue, getValues } = useFormContext();
  const { notifyError } = useNotify();
  const { openModal, closeModal } = useAppModal();
  const { t } = useTranslation();

  const handleSubmit = (values: any) => {
    const newCustomFields = getValues('newCustomFields') || {};

    if (newCustomFields[values.name.toLowerCase()]) {
      notifyError(
        t('pageAutomations.preArrivalForm.errors.customFieldAlreadyExists'),
      );
      return;
    }

    setValue(
      `newCustomFields[${values.name.toLowerCase()}]`,
      {
        id: PreArrivalFormFields.CUSTOM,
        type: values.type,
        name: values.name,
        validation: 'REQUIRED',
        subType: InternalCustomDataFieldSubType.OTHER,
        isActive: true,
      },
      {
        shouldDirty: true,
      },
    );

    closeModal(modalId);
  };

  const openAddCustomFieldModal = () => {
    openModal({
      id: modalId,
      title: t('pageAutomations.preArrivalForm.addCustomField'),
      customContent: (
        <AddCustomFieldModal modalId={modalId} handleSubmit={handleSubmit} />
      ),
    });
  };

  return { openAddCustomFieldModal };
};

export default useAddCustomFieldModal;
